export const defaultAppearance = {
  mode: "always",
  delay_seconds: 0,
  reveal_at: "",
  video_seconds: 0,
};

export const normalizeAppearance = (value) => ({
  ...defaultAppearance,
  ...(value || {}),
});

export const isAppearanceVisible = (value, context = {}, timestamp = Date.now()) => {
  const appearance = normalizeAppearance(value);
  if (appearance.mode === "always") return true;
  if (appearance.mode === "lesson_open") {
    const openedAt = new Date(context.lessonOpenedAt || 0).getTime();
    return openedAt > 0 && timestamp >= openedAt + Number(appearance.delay_seconds || 0) * 1000;
  }
  if (appearance.mode === "date") {
    const revealAt = new Date(appearance.reveal_at || 0).getTime();
    return revealAt > 0 && timestamp >= revealAt;
  }
  if (appearance.mode === "video_time") {
    return Number(context.videoSeconds || 0) >= Number(appearance.video_seconds || 0);
  }
  return true;
};

export const timerState = (timer = {}, context = {}, timestamp = Date.now()) => {
  const durationMs = Math.max(1, Number(timer.duration_seconds || 3600)) * 1000;
  const fixedTarget = new Date(timer.end_at || 0).getTime();
  const startedAt = timer.mode === "fixed_date"
    ? fixedTarget - durationMs
    : new Date(context.lessonOpenedAt || 0).getTime();
  const targetAt = timer.mode === "fixed_date"
    ? fixedTarget
    : startedAt + durationMs;

  if (!Number.isFinite(targetAt) || targetAt <= 0 || startedAt <= 0) {
    return { ready: false, expired: false, remaining: 0, parts: [0, 0, 0, 0] };
  }

  let remaining = targetAt - timestamp;
  const expired = remaining <= 0;
  if (expired && timer.on_expire === "restart") {
    const elapsed = Math.max(0, timestamp - startedAt);
    remaining = durationMs - (elapsed % durationMs || durationMs);
    if (remaining <= 0) remaining = durationMs;
  } else {
    remaining = Math.max(0, remaining);
  }

  const totalSeconds = Math.max(0, Math.ceil(remaining / 1000));
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return { ready: true, expired, remaining, parts: [days, hours, minutes, seconds] };
};
